import { render, staticRenderFns } from "./ModalVerEstadoSeries.vue?vue&type=template&id=636c6c9c&"
import script from "./ModalVerEstadoSeries.vue?vue&type=script&lang=ts&"
export * from "./ModalVerEstadoSeries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('636c6c9c', component.options)
    } else {
      api.reload('636c6c9c', component.options)
    }
    module.hot.accept("./ModalVerEstadoSeries.vue?vue&type=template&id=636c6c9c&", function () {
      api.rerender('636c6c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudStock/ModalVerEstadoSeries.vue"
export default component.exports